import { ButtonEvent } from "appworks/graphics/elements/button-element";
import { Layers } from "appworks/graphics/layers/layers";
import { uiFlags, UIMenuFlag } from "appworks/ui/flags/ui-flags";

export class UIMenuButton {
    constructor(private layer: Layers, private name: string, flag: UIMenuFlag, offFlags?: UIMenuFlag[]) {
        this.layer.onSceneEnter.add((scene: string) => {
            if (scene !== "default") {
                const button = this.layer.getFlexiButton(this.name);

                if (button) {
                    button.on(ButtonEvent.CLICK, () => {
                        // TODO: Remove this if statement.
                        /*if (flag === UIMenuFlag.MENU) {
                            return;
                        }*/
                        uiFlags.menu(flag);

                        if (offFlags) {
                            offFlags.forEach((offFlag) => {
                                uiFlags.menu(offFlag, false);
                            });
                        }
                    });
                }
            }
        });
    }
}
